import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Row, Col } from 'react-bootstrap';
import { Field } from 'redux-form';
import { get } from 'lodash';
import TextInputAdmin from 'components/atoms/inputs/TextInputAdmin';
import IconWrapper from 'components/atoms/IconWrapper';
import StyledLabel from 'components/atoms/inputs/Label';
import ToggleSwitch from 'components/atoms/form/ToggleSwitch';
import ListItemTile from 'components/atoms/layout/ListItemTile';
import { CUSTOM_CHANNEL_PLATFORMS } from 'constants/channels';


const RequiredLabel = styled.label`
    &:before {
        content: ${props => props.required && ("'*'")};
        color: ${props => props.theme.colors.flamepea};
        margin-right: 3px;
    }
`;

const ActionButton = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    cursor: pointer;
    line-height: 0;
    margin-bottom: 5px;
    font-size: 12px;

    :hover {
         span {
            color: #000;
         }
    }
`;

const ActionsWrapper = styled.div`
    position: absolute;
    right: 30px;   
    display: flex;
    flex-direction: column;
    min-height: 20px;
`;

class CustomChannel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fadingOut: false,
        };

        this.handleDelete = this.handleDelete.bind(this);
    }

    getBorderClassName() {
        return [
            get(this.props.embeddedLink, 'new') ? 'new' : false,
            this.state.fadingOut ? 'fadingOut' : false
        ].filter(item => item).join(' ');
    }

    handleDelete() {
        this.setState({
            fadingOut: true
        }, () => {
            this.fadeoutTimer = setTimeout(() => {
                this.fadeoutTimer = null;

                this.props.handleDelete();
            }, 400);
        });
    }

    componentWillUnmount() {
        if (this.fadeoutTimer) {
            clearTimeout(this.fadeoutTimer);
        }
    }

    render() {
        const { embeddedLink = {}, } = this.props;
        return (
            <Fragment>
                <Row>
                    <Col xs={12}>
                        <ListItemTile className={this.getBorderClassName()}>
                            <Row>
                                <Col xs={10}>
                                    <RequiredLabel required>Channel Name</RequiredLabel><br />
                                    <Field component={TextInputAdmin} required={false} label="Yes" type="text"
                                        name={`${this.props.fieldKey}.name`}>
                                    </Field>

                                    <RequiredLabel required>{`${CUSTOM_CHANNEL_PLATFORMS[embeddedLink.platform]} Embed URL`}</RequiredLabel><br />
                                    <Field component={TextInputAdmin} required={false} label="Yes" type="text"
                                        name={`${this.props.fieldKey}.frameUrl`}>
                                    </Field>

                                    <StyledLabel>Visible to Client</StyledLabel><br />
                                    <Field name={`${this.props.fieldKey}.enabled`} component={ToggleSwitch} scale="0.8" />
                                </Col>
                                <Col xs={2}>
                                    <ActionsWrapper>
                                        <ActionButton title="Delete Custom Channel" onClick={this.handleDelete}><IconWrapper className="icon-trash" iconColor="red" width='20px' height='20px' fontSize="20px" marginRight='3px' /><span>Delete</span></ActionButton>
                                    </ActionsWrapper>
                                </Col>
                            </Row>
                        </ListItemTile>
                    </Col>
                </Row>
            </Fragment>
        );
    }
}

CustomChannel.propTypes = {
    fieldKey: PropTypes.string,
    embeddedLink: PropTypes.object,
};

export default CustomChannel;



// WEBPACK FOOTER //
// ./src/components/organisms/entity/edit/CustomChannel.js